export default __webpack_public_path__ + "static/country-club-crush-12647a17814218e02955f756cc58bec9.jpg";